import Header from './index.vue'

export default Header
